import { useEffect, useState } from "react";
import useApi from "../customhook/useApi";
import { useAuth } from "../context/useAuthContext";

const useProjects = () => {
  const { auth } = useAuth();
  const orgId = auth?.orgId;
  const [projects, setProjects] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const getProjects = useApi<any>(
    `/api/v1/master/organizations/${orgId}/projects`,
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const loadProjects = async () => {
    if (!orgId) return;
    setLoading(true);
    try {
      const res = await getProjects.callApi();
      if (res?.success) {
        setProjects(res.data || []);
      }
    } finally {
      setLoading(false);
    }
  }; 
  useEffect(() => {
    loadProjects();
  }, [orgId]);

  return {
    projects,
    loading,
    reload: loadProjects,
  };
};

export default useProjects;
